export enum CreditInformationLabels {
  CheckNumber = "Check Number",
  CheckDate = "Check Date",
  InvoiceNumber = "Invoice Number",
  InvoiceDate = "Invoice Date",
  Purchaser = "Purchaser",
  GrossAmount = "Gross Amount",
  NetAmount = "Net Amount",
  DiscountAmount = "Discount Amount",
  VoucherNumber = "Voucher Number",
  PONumber = "PO Number",
  Description = "Description",
}
